// Module
var code = "<div class=\"im-personsearch-container im-hide\"> <div class=\"im-personsearch-arrow\"></div> <div class=\"im-personsearch-content\"> <ul class=\"im-personsearch-person\"> </ul> </div> </div>";
// Exports
module.exports = code;